class ProductListRecommended extends Component {
	constructor(el) {
		super(el);
		this.collapse = this.$find('[data-collapse]');
		this.button = this.$find('[data-button]');
		if(this.button) {
			this.buttonLess = this.button.dataset.button.trim();
			this.buttonMore = this.button.innerText.trim();
			this.button.addEventListener('click', e => this.toggleCollapse(e));
		}
	}

	toggleCollapse(e) {
		e.preventDefault();
		this.button.innerText = this.button.innerText.trim() === this.buttonLess ? this.buttonMore : this.buttonLess;
		this.collapse.classList.toggle('is-opened');
	}
}

